const FitPulseLogo = ({ size = 32, color = "#0D0D0D" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="64" height="64" rx="14" fill={color} />
    <path
      d="M8 34 L16 34 L20 24 L26 44 L32 18 L38 44 L42 28 L46 34 L48 34"
      stroke="white"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <rect x="48" y="26" width="4" height="16" rx="2" fill="white" />
    <rect x="44" y="30" width="12" height="4" rx="2" fill="white" />
    <rect x="54" y="28" width="4" height="12" rx="2" fill="white" />
  </svg>
);

export default FitPulseLogo;
